import type { PMPluginFactoryParams } from '@atlaskit/editor-common/types';

import type { AiAutocompletePlugin } from './aiAutocompletePluginType';
import { createAiAutocompleteKeymapPlugin } from './pm-plugins/keymap-plugin/ai-autocomplete-keymap';
import { createAiAutocompletePlaceholderControllerPlugin } from './pm-plugins/placeholder-controller/placeholder-controller-plugin';
import { createAutoTriggerSharedState } from './pm-plugins/shared-auto-trigger-state';
import { acceptSuggestionCommand, dismissSuggestionCommand } from './ui/components/commands';
import { createPlugin } from './ui/components/main';

export const aiAutocompletePlugin: AiAutocompletePlugin = ({ api }) => {
	const autoTriggerSharedState = createAutoTriggerSharedState();

	return {
		name: 'aiAutocomplete',
		commands: {
			acceptSuggestion: (params) => acceptSuggestionCommand(params, api?.analytics?.actions),
			dismissSuggestion: () => dismissSuggestionCommand(api?.analytics?.actions),
		},
		pmPlugins() {
			return [
				{
					name: 'aiAutocompletePlugin',
					plugin: () => createPlugin({ api, autoTriggerSharedState }),
				},
				{
					name: 'ai-autocomplete-keymap',
					plugin: (params: PMPluginFactoryParams) =>
						createAiAutocompleteKeymapPlugin({
							api,
							getIntl: params.getIntl,
							autoTriggerSharedState,
						}),
				},
				{
					name: 'ai-autocomplete-placeholder-controller',
					plugin: () => createAiAutocompletePlaceholderControllerPlugin({ api }),
				},
			];
		},
	};
};
